import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const MobileFooter = () => {
  return (
    <div className="footerFixedNav fixed bottom-0 w-full bg-[#fff] px-4 py-1 flex justify-between items-center sm:hidden border-t z-50">
      <NavLink
        activeClassName="active"
        className="flex items-center flex-col cursor-pointer m-1 p-1 rounded-md hover:font-[600]"
        to="/hrms/dashboard"
      >
        <svg
          width="30"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
          fill-rule="evenodd"
          clip-rule="evenodd"
        >
          <path d="M22 11.414v12.586h-20v-12.586l-1.293 1.293-.707-.707 12-12 12 12-.707.707-1.293-1.293zm-6 11.586h5v-12.586l-9-9-9 9v12.586h5v-9h8v9zm-1-7.889h-6v7.778h6v-7.778z"></path>
        </svg>

        <span className="text-xs">Home</span>
      </NavLink>
      <NavLink
        activeClassName="active"
        className="flex items-center flex-col cursor-pointer m-1 p-1 rounded-md hover:font-[600]"
        to="/chats"
      >
        <svg
          fill="#000000"
          width="25"
          height="25"
          version="1.1"
          id="Capa_1"
          viewBox="0 0 60.015 60.015"
        >
          <g>
            <path
              d="M42.007,0h-24c-9.925,0-18,8.075-18,18v14c0,9.59,7.538,17.452,17,17.973v8.344c0,0.688,0.411,1.304,1.047,1.568
		c0.211,0.087,0.433,0.13,0.652,0.13c0.44,0,0.873-0.173,1.198-0.498l1.876-1.876C26.708,52.713,33.259,50,40.227,50h1.781
		c9.925,0,18-8.075,18-18V18C60.007,8.075,51.932,0,42.007,0z M58.007,32c0,8.822-7.178,16-16,16h-1.781
		c-7.502,0-14.555,2.921-19.86,8.226l-1.359,1.359V49v-1v-4c0-0.552-0.448-1-1-1s-1,0.448-1,1v3.949c-8.356-0.52-15-7.465-15-15.949
		V18c0-8.822,7.178-16,16-16h24c8.822,0,16,7.178,16,16V32z"
            />
            <path d="M17.007,19.015h14c0.552,0,1-0.448,1-1s-0.448-1-1-1h-14c-0.552,0-1,0.448-1,1S16.455,19.015,17.007,19.015z" />
            <path d="M44.007,25.015h-27c-0.552,0-1,0.448-1,1s0.448,1,1,1h27c0.552,0,1-0.448,1-1S44.56,25.015,44.007,25.015z" />
            <path d="M44.007,33.015h-27c-0.552,0-1,0.448-1,1s0.448,1,1,1h27c0.552,0,1-0.448,1-1S44.56,33.015,44.007,33.015z" />
          </g>
        </svg>

        <span className="text-xs mt-1">Chats</span>
      </NavLink>
      <NavLink
        activeClassName="active"
        className="flex items-center flex-col cursor-pointer m-1 p-1 rounded-md hover:font-[600]"
        to="/applications"
      >
        <svg
          width="30"
          height="30"
          clip-rule="evenodd"
          fill-rule="evenodd"
          stroke-linejoin="round"
          stroke-miterlimit="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m2.394 15.759s7.554 4.246 9.09 5.109c.165.093.333.132.492.132.178 0 .344-.049.484-.127 1.546-.863 9.155-5.113 9.155-5.113.246-.138.385-.393.385-.656 0-.566-.614-.934-1.116-.654 0 0-7.052 3.958-8.539 4.77-.211.115-.444.161-.722.006-1.649-.928-8.494-4.775-8.494-4.775-.502-.282-1.117.085-1.117.653 0 .262.137.517.382.655zm0-3.113s7.554 4.246 9.09 5.109c.165.093.333.132.492.132.178 0 .344-.049.484-.127 1.546-.863 9.155-5.113 9.155-5.113.246-.138.385-.393.385-.656 0-.566-.614-.934-1.116-.654 0 0-7.052 3.958-8.539 4.77-.211.115-.444.161-.722.006-1.649-.928-8.494-4.775-8.494-4.775-.502-.282-1.117.085-1.117.653 0 .262.137.517.382.655zm10.271-9.455c-.246-.128-.471-.191-.692-.191-.223 0-.443.065-.675.191l-8.884 5.005c-.276.183-.414.444-.414.698 0 .256.139.505.414.664l8.884 5.006c.221.133.447.203.678.203.223 0 .452-.065.689-.203l8.884-5.006c.295-.166.451-.421.451-.68 0-.25-.145-.503-.451-.682zm-8.404 5.686 7.721-4.349 7.72 4.349-7.72 4.35z"
            fill-rule="nonzero"
          ></path>
        </svg>

        <span className="text-xs">Applications</span>
      </NavLink>
      <NavLink
        activeClassName="active"
        className="flex items-center flex-col cursor-pointer m-1 p-1 rounded-md hover:font-[600]"
        to="/account"
      >
        <svg
          width="30"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
          fill-rule="evenodd"
          clip-rule="evenodd"
        >
          <path d="M12 0c-5.083 0-8.465 4.949-3.733 13.678 1.596 2.945-1.725 3.641-5.09 4.418-3.073.709-3.187 2.235-3.177 4.904l.004 1h23.99l.004-.969c.012-2.688-.093-4.223-3.177-4.935-3.438-.794-6.639-1.49-5.09-4.418 4.719-8.912 1.251-13.678-3.731-13.678m0 1c1.89 0 3.39.764 4.225 2.15 1.354 2.251.866 5.824-1.377 10.06-.577 1.092-.673 2.078-.283 2.932.937 2.049 4.758 2.632 6.032 2.928 2.303.534 2.412 1.313 2.401 3.93h-21.998c-.01-2.615.09-3.396 2.401-3.93 1.157-.266 5.138-.919 6.049-2.94.387-.858.284-1.843-.304-2.929-2.231-4.115-2.744-7.764-1.405-10.012.84-1.412 2.353-2.189 4.259-2.189"></path>
        </svg>

        <span className="text-xs">Account</span>
      </NavLink>
    </div>
  );
};

export default MobileFooter;
